/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Dirs_Tooltip_Autosync_OffInputs */

const es_settings_dirs_tooltip_autosync_off = /** @type {(inputs: Settings_Dirs_Tooltip_Autosync_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sincronización automática desactivada`)
};

const en_settings_dirs_tooltip_autosync_off = /** @type {(inputs: Settings_Dirs_Tooltip_Autosync_OffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto-sync disabled`)
};

/**
* | output |
* | --- |
* | "Auto-sync disabled" |
*
* @param {Settings_Dirs_Tooltip_Autosync_OffInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const settings_dirs_tooltip_autosync_off = /** @type {((inputs?: Settings_Dirs_Tooltip_Autosync_OffInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Dirs_Tooltip_Autosync_OffInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_dirs_tooltip_autosync_off(inputs)
	return en_settings_dirs_tooltip_autosync_off(inputs)
});
export { settings_dirs_tooltip_autosync_off as "settings.dirs.tooltip.autosync_off" }